import { gql } from '@apollo/client';

//  Using terminology from https://en.wikipedia.org/wiki/Tree_(data_structure)#Terminology
//
//  * An external node (also known as an outer node, **leaf node**, or terminal node) is any
//  node that does not have child nodes.
//  * An internal node (also known as an inner node, inode for short, or **branch node**)
//  is any node of a tree that has child nodes.
//
//  Choosing **branch** and **leaf** because they provide better mental correlation with biological trees
export const TagNodeFragment = gql`
  fragment TagNodeFields on TagNode {
    ... on TagRoot {
      dummy
    }
    ... on TagLeafSeparator {
      dummy
    }
    ... on TagBranch {
      name
      count
    }
    ... on TagLeafAnyEvent {
      key
      name
    }
    ... on TagLeafAnyTableEvent {
      key
      name
    }
    ... on TagLeafBasicEvent {
      key
      name
      isFavorite
    }
    ... on TagLeafVirtualEvent {
      id
      name
      isFavorite
    }
    ... on TagLeafField {
      key
      name
      isFavorite
      isGeo
    }
    ... on TagLeafFilter {
      id
      name
      isFavorite
    }
    ... on TagLeafSimpleMeasure {
      id
      name
      isFavorite
    }
    ... on TagLeafCompoundMeasure {
      id
      name
      isFavorite
    }
    ... on TagLeafSimpleCohort {
      id
      name
      isFavorite
    }
    ... on TagLeafCompoundCohort {
      id
      name
      isFavorite
    }
    ... on TagLeafEnumBucketDef {
      id
      name
      isFavorite
    }
    ... on TagLeafRangeBucketDef {
      id
      name
      isFavorite
    }
    ... on TagLeafDateBucketDef {
      id
      name
      isFavorite
    }
    ... on TagLeafCustomBucketDef {
      kind
      name
    }
    # Deprecated, to be removed
    ... on TagInlineBranch {
      key
      count
      name
      isFavorite
      type
    }
    ... on TagFieldInlineBranch {
      key
      count
      name
      isFavorite
      type
    }
  }
`;

export const TagMappingFragment = gql`
  fragment TagMappingFields on TagMapping {
    parentIndex
    childrenIndex
  }
`;
